export default __webpack_public_path__ + "static/media/crm.786c0da4.svg";